import { Box } from "@nulogy/components";
import React from "react";
import styled from "styled-components";

const StyledExpandButton = styled(Box)(({ theme }) => ({
  color: theme.colors.blue,
  cursor: "pointer",
  fontSize: theme.fontSizes.small,
  fontWeight: theme.fontWeights.medium,
  marginBottom: theme.sizes.x3,
  marginTop: theme.sizes.x1,
  width: "fit-content",
}));

export default function ExpandFiltersButton({ expandedFilters, onClick }) {
  return (
    <StyledExpandButton onClick={onClick} type="button">
      {expandedFilters ? "Less filters" : "More filters"}
    </StyledExpandButton>
  );
}
